import React from 'react';
import { Box, Container, makeStyles } from '@material-ui/core';

import Page from 'src/components/Page';
import PageHeader from '../components/PageHeader';
import DashboardIcon from '@material-ui/icons/Dashboard';
import DashaboardShorcuts from './DashaboardShorcuts';
const useStyles = makeStyles((theme) => ({
  root: {
    // Bahagyang off-white, hindi purong #ffffff.
    //
    // Puti ang mga card ng shortcut. Sa purong puting page, nawawala ang
    // gilid nila at nakasalalay lang sa manipis na border -- lumulutang
    // ang lahat sa iisang patag na puti. Ang 2% na lamig na ito ay sapat
    // para umangat ang card, pero mukha pa rin itong puting page.
    //
    // Kung purong puti talaga ang gusto, gawing '#ffffff' -- at tingnan
    // ang huling talata ng aking sagot para sa dapat ding baguhin.
    background: '#f7f7fa',
    minHeight: '100%',
    paddingBottom: theme.spacing(4),
    paddingTop: theme.spacing(3),
  },
}));

const Dashboard = () => {
  const classes = useStyles();

  return (
    <Page className={classes.root} title="Dashboard">
      <Container maxWidth={false}>
        <PageHeader icon={<DashboardIcon />} title="Dashboard" showSession />

        <Box mt={4}>
          <DashaboardShorcuts />
        </Box>
      </Container>
    </Page>
  );
};

export default Dashboard;